<template>
  <model-form
    ref="modelForm"
    :model="signageMediaClass"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-gutter-md items-start">
        <q-input
          v-model="signageMediaClass.name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          autofocus
        />
        <q-input
          v-model="signageMediaClass.description"
          class="col"
          label="Description"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
      </div>
    </div>
  </model-form>
</template>
<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'SignageMediaClassForm',
  components: {
    ModelForm
  },
  models: {
    signageMediaClass: 'default'
  }
}

</script>
